<template>
  <div class="d-flex justify-content-end mt-2">
    <div>
      <span @click="setLanguage(option.code)" class="mr-2" :class="{'active': active === option.code}" v-for="option in options" :key="option.code">{{option.name}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'language-dropdown',
  data () {
    return {
      options: [
        {
          code: 'en',
          name: this.$t('language.english')
        },
        {
          code: 'pt',
          name: this.$t('language.portuguese')
        }
      ],
      active: 'pt'
    }
  },
  methods: {
    setLanguage (locale) {
      this.active = locale
      this.$i18n.locale = locale
    },
    currentLanguage () {
      return this.$i18n.locale === 'en' ? 'gb' : this.$i18n.locale
    },
    flagIconClass (code) {
      return `flag-icon-${code} flag-icon-squared`
    }
  }
}
</script>

<style lang="scss">
.language-icon {
  width: 30px;
  height: 30px;
}

.language-title {
  font-size: 1rem;
  text-transform: uppercase;
  color: #29c4a9;
}

.active {
  color: #29c4a9;
}
</style>
